import { IUserListFilter } from '@src/service/business/user/userListBusinessStore';
import ListFilterHelper, { ListFilterQuery } from '@src/service/util/filter/ListFilterHelper';

/** Transform User list filter to API filter */
export function transformUserListFilter(filter: IUserListFilter): ListFilterQuery {
  return ListFilterHelper.simpleFilterToQueryMapper(filter, (filterQuery, name, filterValue) => {
    // process "userGroups"

    if (name === 'userGroups') {
      const value = filterValue[name]; // take filter value for current property

      if (value != null /* empty values should not be added to query */) {
        filterQuery[name] = value.id;
      }
      return true; // signal mapper that this prop has been manually processed
    }

    return false; // signal mapper that this prop has NOT been processed and mapper should apply default mapping
  });
}
